import React, { Component } from 'react';
import Transition from 'react-transition-group/Transition';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module '../AddReview.css' or its corre... Remove this comment to see the full error message
import s from '../AddReview.css';
import { fadeIn, fadeOut } from '../../../core/util/animations';
import withStyles from '../../../core/isomorphic-style-loader/withStyles';

type Props = {
  flowState: string;
  stateToActivateFlow: string;
  toRender: (...args: any[]) => any;
};

class FlowTransition extends Component<Props> {
  render() {
    return (
      <Transition
        in={this.props.flowState === this.props.stateToActivateFlow}
        mountOnEnter
        onEnter={(node) => fadeIn(node, { duration: 1000 })}
        onExiting={(node) => fadeOut(node, { duration: 500 })}
        timeout={500}
        unmountOnExit
      >
        {this.props.toRender()}
      </Transition>
    );
  }
}

export default withStyles(s)(FlowTransition);
